import React from 'react';
import PropTypes from 'prop-types';
import styles from './envelopeSummary.css';
import { DocumentIcon } from '../../Icon';

export const EnvelopeSummaryDocuments = ({ documentName }) => (
    <div className={styles.reviewDocument}>
        <DocumentIcon className="uxf-icon-fill-green" />
        <span>{documentName}</span>
    </div>
);

EnvelopeSummaryDocuments.propTypes = {
    documentName: PropTypes.string
};
